import { observer } from 'mobx-react'
import './index.less'
import { Button, Checkbox, Popover, Radio, Space } from 'antd'
import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import * as Cesium from '@cesiumgs/cesium-analytics'
import InfoCard from '@/components/Content/FacilityLease/InfoCard'
import DetailsCard from '@/components/Content/FacilityLease/DetailsCard'
import useStore from '@/hooks/useStore'
import { downloadModel } from '@/service/facility'

function FacilityLease() {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const facilityStore = useStore('facilityStore')
  const uiStore = useStore('uiStore')
  const mapStore = useStore('mapStore')

  const [floorArr, setFloorArr] = useState<any>([])
  useEffect(() => {
    if (facilityStore.FacilityLeaseInfo !== null && facilityStore.FacilityLeaseInfo.bldgFlrCnt) {
      const arr: any = [
        // { title: '1층', rule: 'F1', checked: true },
        // { title: '2층', rule: 'F2', checked: true },
        // { title: '지붕', rule: 'RF', checked: true },
      ]
      for (let i = 1; i < facilityStore.FacilityLeaseInfo.bldgFlrCnt + 1; i++) {
        arr.push({
          title: `${i}층`,
          rule: `F${i}`,
          checked: true,
        })
      }
      arr.push({
        title: '지붕',
        rule: 'RF',
        checked: true,
      })
      setFloorArr(arr)
    }
  }, [facilityStore.FacilityLeaseInfo])

  const facilityLeaseHide = () => {
    facilityStore.facilityLeaseHide()
  }
  const openTabsPage = () => {
    facilityStore.openTabsPage()
  }

  const radioChange = (e: any) => {
    if (mapStore.viewer) {
      facilityStore.flyToTilest(mapStore.viewer, e.target.value)
    }
  }

  const content = (
    <div className={'FacilityLease-layerBox'}>
      <div className={'layerBody'}>
        <strong className={'layer-title'}>건물 레이어 선택</strong>
        <ul className={'layer-list'}>
          {floorArr.map((item: any, index: number) => (
            <li key={index} className={'layer-item'}>
              <span className={'title'}>{item.title}</span>
              <div className={'chk-item'}>
                <div className={'chk-inner'}>
                  <Checkbox checked={item.checked} onChange={(e) => {
                    const arr = [...floorArr]
                    arr[index].checked = e.target.checked
                    setFloorArr(arr)
                    facilityStore.FacilityTileset && facilityStore.FacilityTileset.readyPromise.then((res: any) => {
                      let defines = {}
                      const conditions = []
                      for (let i = 0; i < arr.length; i++) {
                        defines = {
                          ...defines,
                          [arr[i].rule]: arr[i].rule,
                        }
                        conditions.push([`regExp("\${${arr[i].rule}}.*?").test(\${3ds_mesh_name})`, arr[i].checked ? 'true' : 'false'])
                      }
                      const style = new Cesium.Cesium3DTileStyle({
                        defines,
                        show: {
                          conditions,
                        },
                        meta: {
                          description: '"it is floor"',
                        },
                      })
                      res.style = style
                    })
                  }}>
                    {/* {
                      item.title !== '지붕' ? '벽체' : ''
                    } */}
                  </Checkbox>
                </div>
                <div className={'chk-inner'}>
                  {/* <Checkbox>지붕</Checkbox> */}
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div className={'plan-box'}>
          <strong className={'plan-title'}>카메라 이동</strong>
          <div className={'chk-item'}>
            <Radio.Group onChange={radioChange}>
              <Radio value={'TopView'}>평면도</Radio>
              <Radio value={'AerialView'}>조감도</Radio>
              <Radio value={'PlanningView'}>계획도</Radio>
            </Radio.Group>
          </div>
        </div>
      </div>
    </div>
  )

  const references = (
    <div className={'references-popupBox'}>
       <ul className={'tab1-ul'}>
        <li className={'title'}>
          주변분석 정보출처
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'인구정보'}</span>
          <span className={'value'}>{'SGIS-통계지리정보서비스'}</span>
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'주변환경'}</span>
          <span className={'value'}>{'공공데이터포털'}</span>
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'주요시설'}</span>
          <span className={'value'}>{'공공데이터포털'}</span>
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'교통정보'}</span>
          <span className={'value'}>{'공공데이터포털, 한국도로공사 고속도로 공공데이터포털'}</span>
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'사업체정보'}</span>
          <span className={'value'}>{'SGIS-통계지리정보서비스'}</span>
        </li>
        <li className={'commonLi'}>
          <span className={'key'}>{'관광정보'}</span>
          <span className={'value'}>{'액티부키'}</span>
        </li>
      </ul>
    </div>

  )

  const onDownLoad = () => {
    const id = facilityStore.idlFcltUnqNo
    if (!id)
      return
    const id2 = localStorage.getItem('JSESSIONID') || ''
    const id3 = isDev ? `${window.SystemConfig.facilitySessionId}` : id2
    downloadModel(id, id3).then((res: any) => {
      if (res.code === 200) {
        if (Array.isArray(res.result.idlFcltAtchFileList) && res.result.idlFcltAtchFileList.length > 0) {
          const find = res.result.idlFcltAtchFileList.find((item: any) => item.atchFileSeCd === 'MODEL')
          if (find) {
            const url = window.SystemConfig.rightNavCtrlConfig.downloadModel + find.atchFileList[0].filePath
            downloadFile(url, find.atchFileSeCdNm)
          }
          // res.result.idlFcltAtchFileList.forEach((item: any) => {
          //   const url = window.SystemConfig.rightNavCtrlConfig.downloadModel + item.atchFileList[0].filePath
          //   downloadFile(url, item.atchFileSeCdNm)
          // })
        }
      }
    })
  }

  const downloadFile = (url: string, fileName: string) => {
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
  }

  return (
    <div className={'FacilityLease'}>
      <div>
        <InfoCard />
      </div>
      <div className={'ButtonPart'}>
        <Space size={[4, 4]} wrap>
          <Button onClick={openTabsPage} className={'btn-analyze'}>
            주변정보
          </Button>
          <Popover content={references} placement={'right'} trigger="click">
          <Button icon={<InfoCircleOutlined />} />
          </Popover>
          <Button onClick={onDownLoad} icon={<DownloadOutlined />} />
          <Popover content={content} placement={'right'} trigger="click">
            <Button className={'btn-info'} />
          </Popover>
        </Space>
      </div>
      <div className={'DetailsCardPart'} style={{ height: uiStore.uiHeight - 574 }}>
        {facilityStore.FacilityLeaseCardInfo !== null
          && facilityStore.FacilityLeaseCardInfo.map((item, index) => (
            <DetailsCard
              imgSrc={item.imgSrc}
              name={item.name}
              info1={item.info1}
              info2={item.info2}
              idlFcltUnqNo={item.idlFcltUnqNo}
              flrNo={item.flrNo}
              hoCnt={item.hoCnt}
              brtitleinfoUnqNo={item.brtitleinfoUnqNo}
              key={index}
            />
          ))}
      </div>
      {/* <div className={'FacilityLease-HideButton'}>
        <button className={'btn-fold'} onClick={facilityLeaseHide} />
      </div> */}
      {facilityStore.FacilityLeaseShow === true
        ? <div className={'FacilityLease-HideButton'}>
          <button className={'btn-fold'} onClick={facilityLeaseHide} />
        </div>
        : <div className={'FacilityLease-ShowButton'}>
          <button className={'btn-open'} onClick={facilityLeaseHide} />
        </div>}
    </div>
  )
}

export default observer(FacilityLease)
